const Pusher = require('pusher-js');
import * as PusherTypes from 'pusher-js';
import config from '../../configs/config';
import { getApiKey } from '../../services/common/apiUtils';
import { apm } from '@elastic/apm-rum';

const APP_KEY = config.pusherConfig.APP_KEY;
const APP_CLUSTER = config.pusherConfig.APP_CLUSTER;

let pusher: PusherTypes.default | null = null;

export const initPusher = () => {
	const apiKey = typeof window !== 'undefined' && getApiKey();

	if (apiKey) {
		pusher = (window as any).pusherInst
			? (window as any).pusherInst
			: new Pusher(APP_KEY, {
					cluster: APP_CLUSTER,
			  });
	}

	pusher?.connection?.bind('error', function (err: any) {
		if (err?.error?.data === 4004) {
			try {
				apm.captureError(err);
			} catch (e) {}
		}
	});
	
	typeof window !== 'undefined' && ((window as any).pusherInst = pusher);
};

export { pusher };
